import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Grid2 as Grid, FormGroup, Grid2Props } from "@mui/material";
import { singleGridItem } from "../defaultStyles";
import {
  EDITABLE_MAX_LINES,
  RichTextEditor,
} from "../../../field/richTextEditor//RichTextEditor";
import { useInputFullName } from "../subForms/NamePrefixContext";
import FormLabel from "../../common/base/FormLabel";
import UserAttributeMetadataPaper from "../../attributeMetadata/UserAttributeMetadataPaper";
import { useFormHandlerContext } from "../../../../controllers/formController";

export interface FormRichTextFieldProps extends Grid2Props {
  name?: string;
  label: string;
  labelActions?: React.ReactNode;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  validate?: (value: any) => string | boolean;
}

export const FormRichTextField: React.FC<FormRichTextFieldProps> = ({
  name,
  label,
  labelActions,
  required,
  placeholder,
  disabled = false,
  validate,
  ...grid
}) => {
  const { isProcessing } = useFormHandlerContext();
  const { control } = useFormContext();
  const fullName = useInputFullName(name);

  return (
    <Grid {...singleGridItem} {...grid}>
      <UserAttributeMetadataPaper name={fullName}>
        <Controller
          name={fullName}
          control={control}
          rules={{
            required: required ? `${label} is required` : false,
            validate,
          }}
          render={({ field, fieldState }) => (
            <FormGroup>
              <FormLabel
                required={required}
                label={label}
                name={fullName}
                actions={labelActions}
              />
              <RichTextEditor
                {...field}
                id={fullName}
                fullWidth
                placeholder={placeholder}
                maxLines={EDITABLE_MAX_LINES}
                disabled={disabled || isProcessing}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
              />
            </FormGroup>
          )}
        />
      </UserAttributeMetadataPaper>
    </Grid>
  );
};
